@if (areTimelineFiltersSet) {
  <div class="empty-sticky" [class.expanded]="!isCollapsed">
    <wilson-empty></wilson-empty>

    <p data-test-id="wilson-timeline-empty-filters-state:no-users-found-text">
      {{ 'shift_timeline.no_users_found' | translate }}
    </p>
    <wilson-clear-timeline-filters-button
      class="bottom-button"
    ></wilson-clear-timeline-filters-button>
  </div>
}
